import merge from 'lodash/merge';

const CC_PAYMENT_ALLOWED_CODES = ['us', 'ca', 'uk', 'nz', 'au'];
const DEFAULT_LOCALE = 'en';

export default class User {
  static NAME = 'user';

  static getDetailsConfig = () => ({
    url: '/v1/users/details',
    dataPath: ['userProfileInfo']
  });

  static getTypeConfig = () => ({
    url: '/user-type'
  });

  static getListConfig = () => ({
    url: '/customer/summary/v1/?fields=contactInfo,userRoles',
    dataPath: ['consumers']
  });

  static getUserIntialis = (user) => user?.firstName?.charAt(0)?.toUpperCase() +
    user?.lastName?.charAt(0)?.toUpperCase()

  static getCountryCode = (user) => user?.countryCode || window?.iso_code;

  static getLanguage = (user) => user?.displayLang;

  constructor(user) {
    this.init(user);

    const userContactInfo = user?.contactInfo || {};
    const roles = user?.userRoles || {};

    // this.userId = userContactInfo.userId;
    // this.userName = userContactInfo.userName;
    // this.firstName = userContactInfo.firstName;
    // this.lastName = userContactInfo.lastName;
    this.isSCMS = roles.scms;
    this.isCSR = roles.csr;
    this.locale = user.displayLang || userContactInfo?.country?.languageCode || DEFAULT_LOCALE;
    this.countryCode = userContactInfo?.country?.isoCode || user.countryCode || '';
  }

  init(data) {
    merge(this, data);
  }

  creditCardPaymentAllowed() {
    return CC_PAYMENT_ALLOWED_CODES.includes(this.countryCode.toLowerCase());
  }
}
